export class searchSortOptions {
	pageSize: number;
	pageNumber: number;
	sortColumn: string;
	sortDirection: string;
	searchColumn: string;
	searchText: string; 
	getAll: boolean;

	constructor(pageSize: number, pageNumber: number, sortColumn: string, sortDirection: string,
				searchColumn: string, searchText:  string, getAll: boolean = false) {
		this.pageSize =  pageSize
		this.pageNumber =  pageNumber
		this.sortColumn = sortColumn
		this.sortDirection = sortDirection 
		this.searchColumn = searchColumn
		this.searchText = searchText
		this.getAll = getAll
	}
}